import { FloatingLabelInput, Section } from 'components/ui/index';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { setName, reset } from '../flow/actions';


const propTypes = {
  name: PropTypes.string.isRequired,
};

class NameSection extends PureComponent {
  componentWillUnmount() {
    const { reset } = this.props;
    reset();
  }

  handleChange = newName => this.props.setName(newName)

  render() {
    return (
      <Section title={<FormattedMessage id="page.ReportFilters.sectionNames.name" />}>
        <FloatingLabelInput
          labelText={(
            <FormattedMessage id="page.ReportFilters.reportName">
              {text => <span className="required">{text}</span>}
            </FormattedMessage>
          )}
          handleChange={this.handleChange}
          value={this.props.name}
        />
      </Section>
    );
  }
}

NameSection.propTypes = propTypes;
const mapStateToProps = ({ global, reportSetup }) => ({
  lang: global.language,
  name: reportSetup.setup.name,
});
const mapDispatchToProps = {
  setName,
  reset,
};

export default connect(mapStateToProps, mapDispatchToProps)(NameSection);



// WEBPACK FOOTER //
// ./src/views/ReportFilters/components/NameSection.jsx